import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'ASSESSMENT/Components/ResultList/ResultDetails/resultdetails.css';
import AssessmentApiCall from 'ASSESSMENT/AssessmentApiCall';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';

class ResultDetails extends React.Component {
    constructor(props) {
        super(props);
        let defaultSearchType = this.props.fixedSearchType != undefined
            ? this.props.fixedSearchType
            : this.props.customColumnConfiguration != undefined
                ? this.props.customColumnConfiguration[0] == "hall_ticket"
                    ? "email"
                    : this.props.customColumnConfiguration[0]
                : 'email';

        let defaultSearchInputPlaceholder = defaultSearchType == "university_number"
            ? "University Number"
            : "Registered E-mail Id";

        this.state = {
            resultTitle: this.props.resultTitle,
            resultId: this.props.resultId,
            instituteUrl: this.props.instituteUrl,
            instituteLogo: this.props.instituteLogo,
            instituteName: this.props.instituteName,
            customColumnConfiguration: this.props.customColumnConfiguration,
            filterApplied: false,
            tempFilterAdmissionNumber: this.props.fixedAdmissionNumber != undefined ? this.props.fixedAdmissionNumber : '',
            filterAdmissionNumber: this.props.fixedAdmissionNumber != undefined ? this.props.fixedAdmissionNumber : '',
            admissionNumberWarning: '',
            selectedFieldType: defaultSearchType,
            searchInputPlaceholder: defaultSearchInputPlaceholder,
            resultDetails: [],
            configurationJSON: [],
            studentCGPA: '',
            resultFetching: false,
            isResultPublished: '',
            studentName: '',
            isValidAdmissionNumber: '',

            customHeaderDesign: "",
            customFooterDesign: "",
            parameters: {},
            groupName: '',
            academicYear: '',
            academicBranch: '',
            semesterNumber: '',
        };
    }

    componentDidMount() {
        if (this.props.autoFetchResult && this.state.filterAdmissionNumber != '') {
            this.apiCallToGetResultDetails();
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.autoFetchResult &&
            (
                prevProps.resultId !== this.props.resultId ||
                prevProps.fixedAdmissionNumber !== this.props.fixedAdmissionNumber ||
                prevProps.fixedSearchType !== this.props.fixedSearchType
            )
        ) {
            let selectedFieldType = this.props.fixedSearchType != undefined ? this.props.fixedSearchType : this.state.selectedFieldType;
            let searchInputPlaceholder = selectedFieldType == "university_number" ? "University Number" : "Registered E-mail Id";

            this.setState({
                resultTitle: this.props.resultTitle,
                resultId: this.props.resultId,
                customColumnConfiguration: this.props.customColumnConfiguration,
                tempFilterAdmissionNumber: this.props.fixedAdmissionNumber != undefined ? this.props.fixedAdmissionNumber : '',
                filterAdmissionNumber: this.props.fixedAdmissionNumber != undefined ? this.props.fixedAdmissionNumber : '',
                selectedFieldType,
                searchInputPlaceholder,
                filterApplied: false,
                resultDetails: [],
                configurationJSON: [],
                studentCGPA: '',
                isResultPublished: '',
                studentName: '',
                isValidAdmissionNumber: '',
                customHeaderDesign: '',
                customFooterDesign: '',
                parameters: {},
                groupName: '',
                academicYear: '',
                academicBranch: '',
                semesterNumber: '',
            }, () => {
                if (this.state.filterAdmissionNumber != '') {
                    this.apiCallToGetResultDetails();
                }
            });
        }
    }

    // METHOD TO GET ADMISSION NUMBER
    getAdmissionNumber = (e) => {
        this.setState({
            tempFilterAdmissionNumber: e.target.value
        });

        if(e.target.value.length < 1) {
            this.setState({
                admissionNumberWarning: 'Please enter '+this.state.searchInputPlaceholder+' to get result.'
            });
        }else {
            this.setState({
                admissionNumberWarning: ''
            });
        }
    }

    getKeyValue = (e) => {
        if(e.charCode == 13 || e.which == 13)
        {
            this.validateAdmissionNumber();
        }
    }
    
    // METHOD TO VALIDATE ADMISSION NUMBER
    validateAdmissionNumber = () => {
        let validData = true;

        if(this.state.tempFilterAdmissionNumber.length < 1) {
            this.setState({
                admissionNumberWarning: 'Please enter '+this.state.searchInputPlaceholder+' to get result.'
            });
            validData = false;
        }

        if(validData) {
            this.setState({
                filterAdmissionNumber: this.state.tempFilterAdmissionNumber
            }, () => {
                this.apiCallToGetResultDetails();
            });
        }
    }

    // API CALL TO GET RESULT DETAILS
    apiCallToGetResultDetails = async () => {
        this.setState({
            resultFetching: true
        });

        let requestData = {
            "institute_url": this.state.instituteUrl,
            "result_id": this.state.resultId,
            "admission_number": this.state.filterAdmissionNumber,
            "search_type": this.state.selectedFieldType
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getStudentResult',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetResultDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    resultDetails: apiResult,
                    configurationJSON: jsonResponse.APIResult.configurationJson,
                    groupName: jsonResponse.APIResult.group,
                    academicYear: jsonResponse.APIResult.academicYear,
                    academicBranch: jsonResponse.APIResult.academicBranch,
                    semesterNumber: jsonResponse.APIResult.semesterNumber,
                    customHeaderDesign: jsonResponse.APIResult?.customHeader || "",
                    customFooterDesign: jsonResponse.APIResult?.customFooter || "",
                    studentCGPA: jsonResponse.APIResult?.CGPA || '',
                    resultFetching: false,
                    isResultPublished: jsonResponse.APIResult.resultStatus == 'Not Published' ? false : true,
                    studentName: jsonResponse.APIResult.studentName,
                    isValidAdmissionNumber: jsonResponse.APIResult.isValidAdmissionNumber == 'true' ? true : false,
                    filterApplied: true
                }, ()=> this.replaceStudentGradeCardParameters());
            } else {
                this.setState({
                    resultFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting student result details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO SET FIELD TYPE
    getSearchFieldType = (e) => {
        let searchInputPlaceholder = this.state.searchInputPlaceholder;

        if(e.target.value == "university_number")
        {
            searchInputPlaceholder = "University Number"
        }
        else if(e.target.value == "email")
        {
            searchInputPlaceholder = "Registered E-mail Id"
        }

        this.setState({
            selectedFieldType: e.target.value,
            searchInputPlaceholder
        });
    }

     // METHOD TO REPLACE THE PARAMETERS
    replaceStudentGradeCardParameters = async() => {
        let parameters = this.state.parameters;
        let replaceString;
        parameters["{Academic_Year}"] = this.state.academicYear;
        parameters["{Academic_Branch}"] = this.state.academicBranch;
        parameters["{Semester_Number}"] = this.state.semesterNumber;
        parameters["{Group}"] = this.state.groupName;
        parameters["{Result_Title}"] = this.state.resultTitle;
        let options = { day: 'numeric', month: 'long', year: 'numeric' };
        let date = new Date().toLocaleDateString('en-GB', options);
        parameters["{Todays_Date}"] = date;
        await this.setState({
            parameters,
        })
          
        replaceString = this.replaceTemplateParameters()
        return replaceString
    }

    //FUNCTION TO REPLACE PARAMETERS
    replaceTemplateParameters = () => {
        let replaceString = this.state.customHeaderDesign.toString();
        
        let mapObj = this.state.parameters;
        Object.keys(this.state.parameters).map((key) => {
            replaceString = replaceString.replaceAll(key, (matched) => {
                if (matched == "{Organisation_Logo}") {
                    return `<img src=${mapObj[matched]} height=100 width=100 />`;
                } else if (matched == "{Profile_Picture}") {
                    return `<img src=${mapObj[matched]} height=${this.state.studentExamTableCustomCssObject?.profilePicture?.height || 100} width=${this.state.studentExamTableCustomCssObject?.profilePicture?.width || 100} />`;
                }
                else {
                    return mapObj[matched];
                }
            });
        });

        this.setState({
            customHeaderDesign: replaceString,
        });
        return replaceString
    };

    render () {
        return(
            <>    
                <div className="result-header col-md-12">
                    {
                        !this.props.hideBackButton &&
                        <div className="result-title col-md-9" style={{ paddingLeft: 0 }}>
                            <button className="btn closeDetails-button" title="Click to go back to result list" onClick={() => this.props.closeViewResult()} >
                                <FontAwesomeIcon icon={['fas', 'angle-left']} />
                            </button>
                            <h3>Result - {this.state.resultTitle}</h3>
                        </div>
                    }
                </div>
                <hr />
                {
                    !this.props.hideSearchBlock &&
                        <>
                            <div className="admission-number">
                                <div className='row'>
                                    <label style={{ fontWeight: 'bold' }}>
                                        Search by
                                    </label>
                                    <select className='form-control' value={this.state.selectedFieldType} onChange={(e) => this.getSearchFieldType(e)}>
                                        {
                                            this.state.customColumnConfiguration.includes("university_number") &&
                                                <option value="university_number">University Number / PRN</option>
                                        }
                                        <option value="email">Registered E-mail Id</option>
                                    </select>
                                </div>
                                <div className="search-result col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={"Enter "+this.state.searchInputPlaceholder}
                                        value={this.state.tempFilterAdmissionNumber}
                                        onChange={(e) => this.getAdmissionNumber(e)}
                                        onKeyPress={(e) => this.getKeyValue(e)}
                                    />
                                </div>
                            </div>
                            <p className='text-danger' style={{ fontSize: 14, textAlign:'center' }}>{this.state.admissionNumberWarning}</p>
                            <div className="searchButton">
                                <button className="btn btn-primary" onClick={() => this.validateAdmissionNumber()}>Get Result</button>
                            </div>
                        </>
                }
                {
                    this.state.isValidAdmissionNumber ?
                        <div className="resultDetailsTable col-md-12 table-responsive" ref={el => this.printReference = el}
                        >
                        <style type="text/css" media="print">{"@page { size: auto; }"}</style>
                            {
                                this.state.customHeaderDesign != "" ?
                                    <div className="customHeaderDesign">
                                        {ReactHtmlParser(this.state.customHeaderDesign)}
                                    </div>
                                :
                                    <>
                                        <div className="college-info">
                                            <img className="response-college-logo" alt="college-logo" src={this.state.instituteLogo} />
                                            <p className="response-college-name">{ReactHtmlParser(this.state.instituteName)}</p>
                                        </div>
                                    </>
                            }
                            <div className="studentDetails col-md-12">
                                <div className="result-admission-number" style={{ marginRight: 20 }}>
                                    <span>
                                        <span style={{ fontWeight: 'bold' }}>PRN: </span>
                                        <span>{this.state.filterAdmissionNumber}</span>
                                    </span>
                                </div>
                                <div className="result-student-name">
                                    <span style={{ fontWeight: 'bold' }}>Student Name: </span>
                                    <span>{this.state.studentName}</span>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2" style={{ padding: 5 }}>Subject Code</th>
                                            <th rowSpan="2" style={{ padding: 5 }}>Subject Name</th>
                                            {Object.keys(this.state.configurationJSON).length > 0 &&
                                                Object.keys(this.state.configurationJSON).map((colId, index) => {
                                                    let columnDetails = this.state.configurationJSON[colId];
                                                    let colSpan = 0;
                                                    if(columnDetails.subCol != undefined && Object.keys(columnDetails.subCol).length > 0)  {
                                                        Object.keys(columnDetails.subCol).map(subColId => {
                                                            let subColDetails = columnDetails.subCol[subColId];
                                                            if(subColDetails.displayInWebsite != undefined && subColDetails.displayInWebsite == true) {
                                                                colSpan = colSpan + 1;
                                                            }
                                                        })
                                                    }
                                                    if(columnDetails.displayInWebsite != undefined && columnDetails.displayInWebsite== true) {
                                                        return(
                                                            <th style={{ padding: 5 }} colSpan={colSpan} rowSpan={columnDetails.subCol != undefined ? 1 : 2}>
                                                                {columnDetails.columnName}
                                                            </th>
                                                        );
                                                    }
                                                })
                                            }
                                            {/* <th rowSpan="2" style={{ padding: 5 }}>Credits</th> */}
                                        </tr>
                                        <tr>
                                            {Object.keys(this.state.configurationJSON).length > 0 &&
                                                Object.keys(this.state.configurationJSON).map(colId => {
                                                    let columnDetails = this.state.configurationJSON[colId];
                                                    if(columnDetails.subCol != undefined && Object.keys(columnDetails.subCol).length > 0)  {
                                                        return Object.keys(columnDetails.subCol).map(subColId => {
                                                            let subColumnDetails = columnDetails.subCol[subColId];
                                                            if(subColumnDetails.displayInWebsite != undefined && subColumnDetails.displayInWebsite == true) {
                                                                return(
                                                                    <th style={{ padding: 5 }}>
                                                                        {subColumnDetails.columnName}    
                                                                    </th>
                                                                );
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.isResultPublished ?
                                                <>
                                                    {
                                                        Object.keys(this.state.resultDetails).length > 0 &&
                                                            Object.values(this.state.resultDetails).map(result => {
                                                                if(result != 0)
                                                                {
                                                                    return(
                                                                        <tr>
                                                                            <td style={{ padding: 5 }}>{result.courseCode}</td>
                                                                            <td style={{ padding: 5 }}>{result.subjectName}</td>
                                                                            {this.state.configurationJSON != undefined &&  Object.keys(this.state.configurationJSON).map((colId ,i)=>{
                                                                                let columnDetails = this.state.configurationJSON[colId];
                                                                                if(typeof result[colId] == 'object') {
                                                                                    return columnDetails.subCol != undefined && Object.keys(columnDetails.subCol).map((subColId ,subKeyIndex)=>{
                                                                                        let subColDetails = columnDetails.subCol[subColId];
                                                                                        if(subColDetails.displayInWebsite != undefined && subColDetails.displayInWebsite == true) {
                                                                                            return (
                                                                                                <td style={{ padding: 5 }}>{result[colId][subColId]}</td>
                                                                                            );
                                                                                        }
                                                                                    }) 
                                                                                } else {
                                                                                    if(columnDetails.displayInWebsite != undefined && columnDetails.displayInWebsite == true) {
                                                                                        return (
                                                                                            <td style={{ padding: 5 }}>{typeof result[colId] != 'object' ? result[colId] : '' }</td>
                                                                                        );
                                                                                    }
                                                                                }
                                                                            })}
                                                                            {/* <td style={{ padding: 5 }}>{result.credits}</td> */}
                                                                        </tr>
                                                                    );
                                                                }
                                                            })
                                                    }
                                                    {
                                                        Object.keys(this.state.resultDetails).length > 0 && this.state.resultDetails['SGPA'] != undefined && this.state.resultDetails['SGPA'] > 0 &&
                                                            <tr>
                                                                <td style={{ padding: 5 }}></td>
                                                                <td style={{ padding: 5 }}>{this.props.averageGradePointTitle != undefined ? this.props.averageGradePointTitle : "SGPA"}</td>
                                                                <td style={{ padding: 5 }}>{this.state.resultDetails['SGPA']}</td>
                                                                {
                                                                    this.state.studentCGPA != '' &&
                                                                        <>
                                                                            <td style={{ padding: 5 }}>CGPA</td>
                                                                            <td style={{ padding: 5 }}>{this.state.studentCGPA}</td>
                                                                        </>
                                                                }
                                                            </tr>
                                                    }
                                                </>
                                            :
                                                <tr>
                                                    <td style={{ padding: 5 }} colSpan="20">Result is not yet published. Kindly contact your exam in-charge.</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {
                                this.state.customFooterDesign != "" &&
                                    <div className="customFooterDesign">
                                        {ReactHtmlParser(this.state.customFooterDesign)}
                                    </div>
                            }
                        </div>
                    :
                        this.state.filterApplied &&
                            <div className="invalid-number">
                                <span>Invalid hall ticket number.</span>
                            </div>
                }
                {
                    this.state.isValidAdmissionNumber &&
                        <div className="printResult">
                            <ReactToPrint
                                trigger={() => {
                                    return <button className="btn btn-primary waves-effect" title="Click to print result">
                                                Print Result
                                            </button>;
                                }}
                                content={() => this.printReference}
                            /> 
                        </div>
                }
            </>
        );
    }
}

export default ResultDetails;